import { render, staticRenderFns } from "./organization-config.vue?vue&type=template&id=58c96662&scoped=true"
import script from "./organization-config.vue?vue&type=script&lang=js"
export * from "./organization-config.vue?vue&type=script&lang=js"
import style0 from "./organization-config.vue?vue&type=style&index=0&id=58c96662&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c96662",
  null
  
)

export default component.exports